import LineCtaButton from '@/pages/gmb-audit/consult/components/LineCtaButton';

/**
 * 諮詢頁 Hero（V1 Conversion-1.1）。
 * 兩個清楚入口：Primary 填寫諮詢需求（捲動到表單）、Secondary 加入 LINE。
 * 低壓轉換，無強迫銷售文案。
 */
export default function ConsultHero({ onPrimaryClick }: { onPrimaryClick: () => void }) {
  return (
    <section className="relative overflow-hidden border-b border-background-200 bg-background-100">
      <div className="ds-container py-14 md:py-20">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-sm font-semibold text-primary-800">
            <i className="ri-customer-service-2-line" />
            預約諮詢
          </span>

          <h1 className="mt-5 text-[2rem] font-bold leading-[1.28] tracking-[-0.01em] text-foreground-950 md:mt-6 md:text-[2.75rem] md:leading-[1.2] md:tracking-[-0.02em]">
            看懂問題之後，
            <br className="hidden md:block" />
            下一步是決定先改什麼。
          </h1>

          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-foreground-600 md:mt-6">
            如果你剛完成 Google 商家快速健診，可以把目前最想改善的問題告訴我們。天地人網會依你的商家現況，協助你判斷適合先處理 Google 商家、網站、LINE、內容曝光，還是其他數位接單環節。
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4">
            <button
              type="button"
              onClick={onPrimaryClick}
              className="inline-flex h-14 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-primary-700 px-7 text-base font-semibold text-background-50 transition-colors hover:bg-primary-800 sm:w-auto"
            >
              <i className="ri-edit-2-line text-lg" />
              填寫諮詢需求
            </button>
            <LineCtaButton fullWidth className="sm:w-auto" />
          </div>

          <p className="mt-4 text-base text-foreground-500">
            不想填表單？也可以直接加入 LINE 與我們討論。
          </p>

          <p className="mt-4 text-base text-foreground-500">
            先了解方向，不代表一定要購買服務。
          </p>
        </div>
      </div>
    </section>
  );
}